<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/book/list' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title">绘本图片</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">

        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加绘本图片</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <InputNumber :min="0" v-model="row.sort" @on-blur="OnBlur(row)"/>
        </template>
        <template slot-scope="{ row, index }" slot="pic">
          <div class="tabBox_img" v-if="row.pic !== ''">
            <img :src="row.pic">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
    <modalSure ref="modalSure" title="绘本图片" :id="id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
  import { detailList, delDetail } from '@/api/book'
  import modalSure from '@/components/modalSure'
  export default {
    name: 'roomList',
    components: { modalSure },
    inject: ['reload'],
    data () {
      return {
        userForm: {
          page: 1,
          limit: 10,
          key: '',
          book_id: 0
        },
        grid: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 7,
          xl: 7
        },
        modelApi: delDetail,
        dataCount: 0,
        formInfo: [],
        loading: false,
        id: 0,
        columns2: [
          {
            title: 'ID',
            key: 'id',
            minWidth: 50
          },
          {
            title: '图片',
            slot: 'pic',
            minWidth: 120
          },
          {
            title: '开始秒数',
            key: 'second',
            minWidth: 120
          },
          {
            title: '操作',
            slot: 'action',
            fixed: 'right',
            minWidth: 120
          }
        ]
      }
    },
    created () {
      if (this.$route.params.pid !== '0' && this.$route.params.pid) {
        this.userForm.book_id = this.$route.params.pid
        this.detailList()
      }
    },
    methods: {
      detailList () {
        this.loading = true
        detailList(this.userForm).then(res => {
          let data = res.data
          this.formInfo = data.list
          this.dataCount = data.count
          this.loading = false
        }).catch(res => {
          this.loading = false
          this.$Message.error(res.msg)
        })
      },
      // 分页
      changepage (status) {
        this.userForm.page = status
        this.detailList()
      },
      // 表格搜索
      userSearchs () {
        this.userForm.page = 1
        this.detailList()
      },
      selectChange () {
        this.userForm.key = ''
      },
      edit (id) {
        this.$router.push({ path: '/admin/book/detail/add/' + this.userForm.book_id + '/' + id })
      },
      updateStatusModel (modalStatus) {
        this.editShow = modalStatus
        this.reload()
      },
      // 添加
      add () {
        this.$router.push({ path: '/admin/book/detail/add2/' + this.userForm.book_id })
      },
      del (row) {
        this.id = row.id
        this.$refs.modalSure.isShow = true
      },
      closeModal (val) {
        this.detailList()
      },
    }
  }
</script>
